module.exports = __webpack_public_path__ + "static/media/capa-historia-mobile.460912b8.png";